import React from "react";
import { Link } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import SEO from '../components/SEO';
import {
  FaLaptopCode,
  FaPaintBrush,
  FaCogs,
  FaImages,
  FaSchool,
  FaBoxes
} from "react-icons/fa";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
// import HeroSlider from '../components/HeroSlider';
import bg1 from '../assets/bg1-s.webp'; // Adjust path as per your folder structure
import ServicesSlider from '../components/ServiceSlider';




function Home() {
 const services = [
  {
    icon: <FaLaptopCode className="text-4xl text-[#0a3c6d]" />,
    title: "Website Development",
    desc: "Responsive and SEO-optimized websites tailored to your business.",
  },
  {
    icon: <FaPaintBrush className="text-4xl text-[#0a3c6d]" />,
    title: "Website Designing",
    desc: "Visually attractive, user-friendly designs that engage your audience.",
  },
  {
    icon: <FaCogs className="text-4xl text-[#0a3c6d]" />,
    title: "Software Development",
    desc: "Custom business software to boost productivity and operations.",
  },
  {
    icon: <FaImages className="text-4xl text-[#0a3c6d]" />,
    title: "Graphic Design",
    desc: "Professional designs for branding, marketing, and UI/UX needs.",
  },
  {
    icon: <FaSchool className="text-4xl text-[#0a3c6d]" />,
    title: "School Management System",
    desc: "Complete ERP for schools with attendance, exams, fees & more.",
  },
  {
    icon: <FaBoxes className="text-4xl text-[#0a3c6d]" />,
    title: "Inventory Management",
    desc: "Track, manage, and organize stock across your business.",
  },
];

const slides = [
  {
    title: 'Software Development Company',
    description:
      'Imagine having a software partner that understands your business needs and turns ideas into powerful software.',
    panelTheme: 'theme1',
    mainFeature: {
      title: 'Software Development',
      subtitle: 'Power Efficiency',
      link: '/software-development',
      desc: 'Custom software, mobile apps, and collaboration tools.',
    },
    features: [
      {
        title: 'Custom Software Development',
        desc: 'Turn your ideas into scalable custom applications.',
        link: '/software-development/custom-software-development',
      },
      {
        title: 'Enterprise Mobile Applications',
        desc: 'Secure, scalable mobile solutions.',
        link: '/software-development/enterprise-mobile-applications',
      },
      {
        title: 'Online Collaboration Platforms',
        desc: 'Facilitate team productivity.',
        link: '/software-development/online-collaboration-platforms',
      },
      {
        title: 'Digital Learning Solutions',
        desc: 'Scalable e-learning platforms.',
        link: '/software-development/digital-learning-solutions',
      },
    ],
  },
  {
    title: 'Website Design & Development',
    description:
      'Imagine having a website that makes you stand out, is easy to navigate, and responsive on all devices.',
    panelTheme: 'theme2',
    mainFeature: {
      title: 'Website Design',
      subtitle: 'Build Credibility',
      link: '/website-design',
      desc: 'Build credibility and stay ahead of the digital game with responsive, user-friendly website design that attracts and converts.',
    },
    features: [
      {
        title: 'Wordpress Website Design',
        desc: 'Website design using the Wordpress CMS.',
        link: '/website-design/wordpress-website-development',
      },
      {
        title: 'Corporate Website Design',
        desc: 'Website design using enterprise-level CMS platforms.',
        link: '/website-design/corporate-website-development',
      },
      {
        title: 'eCommerce Website Design',
        desc: 'Build your online store using platforms like Magento.',
        link: '/website-design/ecommerce-website-development',
      },
      {
        title: 'Website Hosting and Support',
        desc: 'One-stop-shop for website design, hosting, and maintenance.',
        link: '/website-design/website-hosting-support',
      },
    ],
  },
  
  {
    title: 'Digital Marketing Services',
    description:
      'Imagine a digital strategy that combines SEO, content marketing, and social media to convert leads.',
    panelTheme: 'theme3',
    mainFeature: {
      title: 'Digital Marketing',
      subtitle: 'Drive Growth & Revenue',
      link: '/digital-marketing',
      desc: 'SEO, PPC, content, and social strategies that deliver.',
    },
    features: [
      {
        title: 'Search Engine Optimisation (SEO)',
        desc: 'Grow visibility through organic search.',
        link: '/digital-marketing/search-engine-optimisation-seo',
      },
      {
        title: 'Search Engine Marketing (SEM)',
        desc: 'Maximize ROI with PPC ads.',
        link: '/digital-marketing/search-engine-marketing-sem',
      },
      {
        title: 'Content Marketing',
        desc: 'Engage with quality content.',
        link: '/digital-marketing/content-marketing',
      },
      {
        title: 'Social Media Marketing',
        desc: 'Build trust and online engagement.',
        link: '/digital-marketing/social-media-marketing-smm',
      },
    ],
  },
];

const title="AKHSoft | Software Development, ERP, Web Design & Digital Marketing";
const description = "Learn more about AKHSoft and our professional software services.";
const keywords = "AKHSoft, About Us, Software Company, Web Development";
const path = typeof window !== "undefined" ? window.location.pathname : "";


  return (
    <>
    
    <SEO 
      title={title}
      description={description}
      keywords={keywords}
        path={path}
    />
    <div className="w-[100%] max-w-[1910px] mx-auto">
    <section className="bg-gray-50">
      {/* Main Slider (from HTML converted) */}
    



<div
  className="min-h-[60vh] flex items-center bg-cover bg-top text-white px-6"
  style={{ backgroundImage: `url(${bg1})` }}
>
  <div className="max-w-4xl text-left md:ml-12">
    <h1 className="text-4xl md:text-5xl font-bold mb-4">
      Empowering Your Business in the Digital Era
    </h1>
    <p
      className="mb-6"
      style={{ fontSize: "21px", fontWeight: 400 }}
    >
      We craft innovative digital solutions that enhance efficiency, accelerate growth, and build lasting trust with your customers.
    </p>
    <div className="flex gap-4">
  <Link
  to="#"
  className="bg-[#ffa10f] text-white px-5 py-2 rounded border border-[#ffa10f] hover:bg-[#e68e00] transition font-semibold"
>
  Read More
</Link>

<Link
  to="#"
  className="bg-[#8cc540] text-white px-5 py-2 rounded border border-[#8cc540] hover:bg-[#7bb032] hover:text-white transition font-semibold"
>
  Contact Us
</Link>
    </div>
  </div>
</div>

<section className="py-12 px-4">
  
  <ServicesSlider slides={slides}/>
</section>
       

      {/* About Section */}
      <div className="bg-white border-t py-16 px-6 text-center mt-6">
        <h2 className="text-3xl font-bold text-center mb-12 text-[#0a3c6d]">Why Choose AKHSoft?</h2>
        <p className="max-w-4xl mx-auto text-gray-700 leading-relaxed">
          AKHSoft offers comprehensive software development services — from custom ERP and mobile apps to UI/UX, web tools,
          and ongoing maintenance. We serve various sectors including education, retail, healthcare, and more.
          Whether you need a mobile-connected ERP, powerful dashboards, or a sleek website, we ensure quality,
          continuous support, and top-tier performance.
        </p>
      </div>

      {/* CTA Section */}
     <div className="bg-gradient-to-r from-[#0a3c6d] to-[#0e4a80] py-10 text-center px-4 text-white">
  <h3 className="text-2xl font-semibold mb-2">Have a Project in Mind?</h3>
  <p className="mb-4">Let’s build something great together. We’re ready to help you succeed.</p>
  <Link
    to="#"
    className="bg-white text-[#0a3c6d] px-5 py-2 rounded hover:bg-gray-100 transition font-semibold"
  >
    Contact Us
  </Link>
</div>

    </section>
    </div>
    </>
  );
}
export default Home;